import { useNavigate, Link } from 'react-router-dom'
import { Cookies } from 'react-cookie';

const cookies = new Cookies();

const Header = ({ setOpen, open }) => {
    let UserName = cookies.get('userName');
    let UserCode = cookies.get('loginUserCode')

    const navigate = useNavigate()
    const handleSignOut = async () => {
        await cookies.remove('token');
        await cookies.remove('userName');
        await cookies.remove('loginUserCode');
        navigate('/');
    };

    const handleDownloadClick = () => {
        const apkUrl = 'http://mega.sagarinfotech.com/TrackMate.apk';
        const link = document.createElement('a');
        link.href = apkUrl;
        link.download = 'TrackMate.apk';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <>
            <header id="header" className="header fixed-top d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center justify-content-between">
                    <Link className="logo d-flex align-items-center">
                        <span className="d-none d-lg-block logo brand">
                            {open ? <img src="assets/img/Trackmate-logo.png" alt="" /> : <img src="assets/img/Trackmate-logo.png" alt="" />}
                           
                        </span>
                    </Link>
                    <Link className="logo d-flex align-items-center">
                        <span className="d-none d-lg-block logo brand1">
                            <img src="./assets/img/logo-text.png"alt="" />
                        </span>
                    </Link>
                    {/*<i className="bi bi-list toggle-sidebar-btn " style={{ marginLeft: "100px" }} onClick={() => setOpen(!open)} />*/}
                    <i className="bi bi-list toggle-sidebar-btn " onClick={() => setOpen(!open)} />
                   

                </div>
                <div className="d-flex align-items-center justify-content-between">
                

                    {/*&nbsp;&nbsp;&nbsp;*/}
                    {/*<span onClick={() => handleDownloadClick()} className="text-light" style={{ fontSize: "14px", color: 'blue', }}>*/}
                    {/*    <i class="fa fa-mobile" aria-hidden="true" style={{ fontSize: "14px", color: 'gray', cursor: 'pointer', }}></i> <u style={{ fontSize: "14px", color: 'blue', cursor:'pointer', }}>Download APK</u>*/}
                    {/*</span>*/}
                </div>


              
                <nav className="header-nav">
                    <ul className="d-flex align-items-center">
                        <li className="nav-item dropdown pe-3">
                            <button

                                className="nav-link nav-profile d-flex align-items-center pe-0"
                                data-bs-toggle="dropdown"
                            >
                                <img
                                    src="assets/img/profile-img.Png"
                                    alt="Profile"
                                    className="rounded-circle"
                                />
                                <span className="d-none d-md-block dropdown-toggle ps-2">
                                    {`${UserName} (${UserCode})`}
                                </span>

                            </button>
                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                <li className="dropdown-header content-left-align">
                                    <h6>{UserName}</h6>
                                    <span>UserCode: {UserCode}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li>
                                    <button className="dropdown-item d-flex align-items-center" onClick={handleSignOut}>
                                        <i className="bi bi-box-arrow-right" />
                                        <span>Sign Out</span>
                                    </button>
                                </li>
                            </ul>
                            
                        </li>
                       
                    </ul>
                </nav>
            </header>
        </>
    )
}
export default Header